import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const ImageIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <Path d="M0.771429 17.2286H17.2286V11.7429M0.771429 17.2286V0.771429H17.2286V11.7429M0.771429 17.2286L11.7429 9L17.2286 11.7429M8.31429 6.25714C8.31429 7.39327 7.39327 8.31429 6.25714 8.31429C5.12101 8.31429 4.2 7.39327 4.2 6.25714C4.2 5.12101 5.12101 4.2 6.25714 4.2C7.39327 4.2 8.31429 5.12101 8.31429 6.25714Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

ImageIcon.displayName = 'ImageIcon';
